import { createSelector } from 'reselect'
import { REFERENCES_DOMAIN } from 'modules/training/modules/references/constants'

function getReferencesSelector (path) {
  return createSelector(
    state => state[REFERENCES_DOMAIN],
    domain => domain[path] || []
  )
}

export default getReferencesSelector
